import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  withIcon?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  withIcon = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-terracotta';
  const variants = {
    primary: 'bg-terracotta text-white hover:bg-terracotta-dark shadow-lg shadow-terracotta/20',
    secondary: 'bg-cream-dark text-warm-dark hover:bg-peach hover:text-warm-black',
    outline: 'border-2 border-terracotta text-terracotta hover:bg-terracotta/5'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg font-bold'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} {...props} data-id="element-182">
      {children}
      {withIcon && <ArrowRight className="ml-2 h-5 w-5" data-id="element-183" />}
    </motion.button>;
}